<template>
  <div v-if="data" id="main" class="reportContainer">
    <div class="coverContainer">
      <img :src="topImg" alt="">
      <div class="coverInfo">
        {{ pageInfo.school }}
      </div>
    </div>
    <IntroBase />
    <div class="bigTitle partTest" />
    <SamllTitle title="参测人员概况" />
    <div class="formatIntro">
      本次心理健康测评<span>{{ pageInfo.school }}</span>应参测人数<span>{{ baseData.yinCeRenShu }}</span>人，实际参测人数<span>{{ baseData.shiCeRenShu }}</span>人，有效问卷人数<span>{{ baseData.youXiaoWenJuan }}</span>人，有效率<span>{{ (baseData.youXiaoLu * 100).toFixed(2) }}%</span>。
    </div>
    <TableList
      class="wsTableList"
      table-title="参测人员概况"
      cell-color="#FAB839"
      tip="*说明:有效问卷是指学生回答测评符合测评要求"
      :headers="SurveyPersonnelHeadersList"
      :table-data="SurveyPersonnelBodyList"
    />
    <SamllTitle title="男／女生参测人员分布情况" style="margin-top: 81px" />
    <div class="pieChart">
      <div id="piePercentageChart" class="pie" />
    </div>
    <div class="formatIntro">
      本次心理健康测评<span>{{ pageInfo.school }}</span>实际参测人数<span>{{ baseData.shiCeRenShu }}</span>人，女生<span>{{ baseData.shiCeRenShuFemale }}</span>人，占比<span>{{ (baseData.shiCeRenShuFemaleRate * 100).toFixed(2) }}%</span>；男生<span>{{ baseData.shiCeRenShuMan }}</span>人，占比<span>{{ (baseData.shiCeRenShuMan_Rate * 100).toFixed(2) }}%</span>；
    </div>
    <SamllTitle title="各年级参测人员分布情况" style="margin-top: 81px" />
    <div class="pieChart">
      <div id="pieClassChart" class="pie" />
    </div>
    <div class="formatIntro">
      本次心理健康测评<span>{{ pageInfo.school }}</span>实际参测人数<span>{{ baseData.shiCeRenShu }}</span>人
      <div v-for="(gradeTotal, index) in pieGradeChartData.value" :key="index">
        {{ gradeTotal.name }}<span>{{ gradeTotal.value }}</span>人，占比<span>{{
          ((gradeTotal.value / baseData.shiCeRenShu) * 100).toFixed(2)
        }}%</span>；
      </div>
    </div>
    <div class="bigTitle resultT" />
    <SamllTitle title="学生心理健康总体情况" style="margin-top: 100px" />
    <div class="listContainer">
      <div class="listItem">
        <div class="listTitle">
          <div class="icon" />
          <div class="title">学生心理健康状态汇总</div>
        </div>
        <div class="listValue">
          <div class="pieChart">
            <div id="healthSummaryChart" class="pie" />
          </div>
          <div class="formatIntro">
            参照《儿少心理健康量表》5种健康状态常模，在本次心理健康测评中，
            <div
              v-for="(health, index) in HealthSummaryPieChartData"
              :key="index"
            >
              处于{{ health.name }}的学生有<span>{{ health.value }}</span>人，占比<span>{{
                ((health.value / baseData.shiCeRenShu) * 100).toFixed(2)
              }}%</span>；
            </div>
          </div>
          <TableList
            is-show-top-tip
            table-title="参照资料"
            :headers="healthSummaryHeaders"
            :table-data="healthSummaryDataList"
          />
        </div>
      </div>
      <div class="listItem">
        <div class="listTitle">
          <div class="icon" />
          <div class="title">各年级学生心理健康状态汇总</div>
        </div>
        <div class="listValue">
          <div class="pieChart">
            <div id="barClassChart" class="pie" />
          </div>
          <div class="formatIntro">
            参照《儿少心理健康量表》5种健康状态常模，在本次心理健康测评中，
            <p v-html="gradeChartData.remark" />
          </div>
        </div>
      </div>
      <div class="listItem">
        <div class="listTitle">
          <div class="icon" />
          <div class="title">各班级心理健康状态汇总</div>
        </div>
        <div
          v-for="(item, index) in gradeAboutClassChartData"
          :key="index"
          class="listValue"
        >
          <div class="pieChart">
            <div :id="`barEachClassChart${index}`" class="pie" />
          </div>
          <div class="formatIntro" style="margin-top: 0">
            参照《儿少心理健康量表》5种健康状态常模，在本次心理健康测评中，男/女生的具体情况如下：
            <div v-html="item.remark" />
          </div>
        </div>
      </div>
      <div class="listItem">
        <div class="listTitle">
          <div class="icon" />
          <div class="title">男／女生心理健康状态汇总</div>
        </div>
        <div class="listValue">
          <div class="pieChart">
            <div id="barGradeBaGChart" class="pie" />
          </div>
          <div class="formatIntro" style="margin-top: 0">
            参照《儿少心理健康量表》5种健康状态常模，在本次心理健康测评中，男/女生的具体情况如下：
            <div v-for="(Bag, index) in barGradeBaGChart.name" :key="index">
              处于{{ Bag }}的男生有<span>{{ barGradeBaGChart.man[index] }}</span>人，女生有<span>{{ barGradeBaGChart.male[index] }}</span>人
            </div>
          </div>
        </div>
      </div>
    </div>
    <SamllTitle title="学生心理健康预警情况" style="margin-top: 88px" />
    <div class="listContainer">
      <div class="listItem">
        <div class="listTitle">
          <div class="icon" />
          <div class="title">分级预警人数汇总</div>
        </div>
        <div class="listValue">
          <div class="pieChart">
            <div id="EarlyPieChart" class="pie" />
          </div>
          <div class="formatIntro" style="margin-top: 0">
            参照分级预警的操作定义，在本次心理健康测评中，
            <div v-for="(alert, index) in EarlyPieChartData" :key="index">
              {{ alert.name }}有<span>{{ alert.value }}</span>人,占比<span>{{
                ((alert.value / baseData.shiCeRenShu) * 100).toFixed(2)
              }}%</span>；
            </div>
          </div>
          <div class="formatIntro" style="margin-top: 0">
            *分级预警的操作定义：
          </div>
          <div class="formatIntro" style="margin-top: 0">
            第一类预警：5个维度中的任一维度处于预警状态。
          </div>
          <div class="formatIntro" style="margin-top: 0">
            第二类预警：至少有3个维度为预警状态的学生，且其中1个为情绪维度。
          </div>
          <div class="formatIntro" style="margin-top: 0">
            第三类预警：第24题选择选项G（我有意摧残自己的健康，有自残或自杀行为。）
          </div>
        </div>
      </div>
      <div class="listItem">
        <div class="listTitle">
          <div class="icon" />
          <div class="title">各年级分级预警人数汇总</div>
        </div>
        <div class="listValue">
          <div class="pieChart">
            <div id="gradeBarChart" class="pie" />
          </div>
          <div class="formatIntro" style="margin-top: 0">
            参照分级预警的操作定义，在本次心理健康测评中，
            <div v-html="data.alarmItemsRemark" />
          </div>
        </div>
      </div>
      <div class="listItem">
        <div class="listTitle">
          <div class="icon" />
          <div class="title">各班级分级预警人数汇总</div>
        </div>
        <div class="listValue">
          <div class="pieChart">
            <div id="level1EarlyBarChart" class="pie" />
          </div>
          <div class="formatIntro" style="margin-top: 0">
            参照分级预警的操作定义，在本次心理健康测评中， 第一类预警中
            <div v-for="(item, index) in early1Data.className" :key="index">
              {{ item }}学生有<span>{{ early1Data.value[index] }}</span>人
            </div>
            。
          </div>
          <div class="pieChart">
            <div id="level2EarlyBarChart" class="pie" />
          </div>
          <div class="formatIntro" style="margin-top: 0">
            参照分级预警的操作定义，在本次心理健康测评中， 第二类预警中
            <div v-for="(item, index) in early2Data.className" :key="index">
              {{ item }}学生有<span>{{ early2Data.value[index] }}</span>人
            </div>
            。
          </div>
          <div class="pieChart">
            <div id="level3EarlyBarChart" class="pie" />
          </div>
          <div class="formatIntro" style="margin-top: 0">
            参照分级预警的操作定义，在本次心理健康测评中， 第三类预警中
            <div v-for="(item, index) in early3Data.className" :key="index">
              {{ item }}学生有<span>{{ early3Data.value[index] }}</span>人
            </div>
            。
          </div>
        </div>
      </div>
    </div>
    <SamllTitle title="各维度心理健康状态分析" style="margin-top: 88px" />
    <div class="listContainer">
      <div class="listItem">
        <div class="listTitle">
          <div class="icon" />
          <div class="title">各维度心理健康状态分布表</div>
        </div>
        <div
          v-for="(value, key, i) in data.scaleItems"
          :key="i"
          class="listValue"
          style="padding-top: 45px"
        >
          <ComplexTableList
            :key="i"
            :table-title="
              '<span>' +
                pageInfo.school +
                '</span>' +
                '各年级学生在' +
                '<span>' +
                key +
                '</span>' +
                '的心理健康状态分布表'
            "
            :table-data="{ value: formatTableValueData(key), key: key }"
            show-summary
            is-school="年级"
          />
        </div>
        <TableList
          is-show-top-tip
          table-title="参照资料"
          :headers="weiduTableHeadersList"
          :table-data="weiduTableDataList"
        />
      </div>
      <div class="listItem">
        <div class="listTitle">
          <div class="icon" />
          <div class="title">各维度预警状态概述</div>
        </div>
        <div class="listValue" style="padding-top: 45px">
          <div class="pieChart">
            <div id="barDimentionChart" class="pie" />
          </div>
          <div class="formatIntro" style="margin-top: 0">
            本次心理健康测评中，{{
              pageInfo.school
            }}学生在各维度处于预警状态的具体情况如下：
          </div>
          <div class="formatIntro" v-html="barDimentionChartData.remark" />
        </div>
      </div>
    </div>
    <div class="bigTitle summaryT" />
    <div class="intro">
      <div class="introItem">
        学生总体心理健康情况如上，但有个别学生的心理状态需要特别关注，建议学校提供相应的专业评估与心理支持。本测评结果不能作为医学诊断。
      </div>
    </div>
    <div
      v-if="
        schoolType == '0' ||
          schoolType == '1' ||
          schoolType == '2' ||
          schoolType == '99'
      "
      class="bigTitle scienceT"
    />
    <Science :school-type="schoolType" />
    <div class="bigTitle noticeT" />
    <div class="intro">
      <div class="introItem">
        本测评报告不可作为精神疾病、心理障碍诊断的依据，仅供参考。
      </div>
    </div>
  </div>
</template>
<script>
import SamllTitle from '../../components/smallTitle.vue'
import TableList from '../../components/tableList.vue'
import ComplexTableList from '../../components/complexTableList.vue'
import Science from '../../components/science.vue'
import IntroBase from '../../components/introBase.vue'
// import request from "../../utils/request";
// import getReportPdf from "../../utils/getReportPdf";
import htmlToPdf from '../../utils/htmlToPdf'
// import Html2Canvas from "html2canvas";
import { mixins } from '../../utils/mixins'
import {
  getChildrenTeamReportDetailData,
  getChildrenTeamReportItemdetail2Data
} from '../../api/report'
// import { jsPDF } from "jspdf";
export default {
  components: {
    SamllTitle,
    TableList,
    Science,
    IntroBase,
    ComplexTableList
  },
  mixins: [mixins],
  data() {
    return {
      topImg: require('../../assets/images/schoolReport/cover.png'),
      pageInfo: {
        reportType: 3,
        province: '湖南省',
        city: '长沙市',
        district: '雨花区',
        school: '1'
      },
      baseData: {},
      data: undefined,
      SurveyPersonnelHeadersList: [
        { label: '应参测人数', key: 'totalTest' },
        { label: '实际参测人数', key: 'ActualTest' },
        { label: '有效问卷人数', key: 'effectiveTest' },
        { label: '有效率', key: 'efficientTest' }
      ],
      SurveyPersonnelBodyList: [],
      pieGradeChartData: {
        name: [],
        value: []
      },
      HealthSummaryPieChartData: [],
      healthSummaryHeaders: [
        { label: '高健康状态', key: 'high' },
        { label: '较好健康状态', key: 'preferably' },
        { label: '一般健康状态', key: 'commonly' },
        { label: '亚健康状态', key: 'subhealthy' },
        { label: '预警状态', key: 'early' }
      ],
      healthSummaryDataList: [
        {
          high: '101-120分',
          preferably: '81-100分',
          commonly: '61-80分',
          subhealthy: '41-60分',
          early: '24-40分'
        }
      ],
      gradeChartData: {
        name: [],
        value: [],
        remark: ''
      },
      gradeAboutClassChartData: [],
      barGradeBaGChart: {
        name: [],
        man: [],
        male: []
      },
      EarlyPieChartData: [],
      earlyGrade: {
        gradeName: [],
        value: [],
        name: []
      },
      early1Data: {
        className: [],
        value: []
      },
      early2Data: {
        className: [],
        value: []
      },
      early3Data: {
        className: [],
        value: []
      },
      weiduTableHeadersList: [
        { label: '维度', key: 'weidu' },
        { label: '高健康状态', key: 'high' },
        { label: '较好健康状态', key: 'preferably' },
        { label: '一般健康状态', key: 'commonly' },
        { label: '亚健康状态', key: 'subhealthy' },
        { label: '预警状态', key: 'early' }
      ],
      weiduTableDataList: [
        {
          weidu: '认知维度',
          high: '21-25分',
          preferably: '17-20分',
          commonly: '11-16分',
          subhealthy: '8-10分',
          early: '5-7分'
        },
        {
          weidu: '思维与语言维度',
          high: '22-25分',
          preferably: '19-21分',
          commonly: '13-18分',
          subhealthy: '9-12分',
          early: '5-8分'
        },
        {
          weidu: '个性维度',
          high: '27-30分',
          preferably: '22-26分',
          commonly: '14-21分',
          subhealthy: '10-13分',
          early: '6-9分'
        },
        {
          weidu: '情绪维度',
          high: '14-15分',
          preferably: '11-13分',
          commonly: '7-10分',
          subhealthy: '5-6分',
          early: '3-4分'
        },
        {
          weidu: '意志行为维度',
          high: '22-25分',
          preferably: '18-21分',
          commonly: '12-17分',
          subhealthy: '8-11分',
          early: '5-7分'
        }
      ],
      barDimentionChartData: {
        dimentionName: [],
        value: [],
        className: [],
        remark: ''
      },
      schoolType: ''
    }
  },
  created() {
    if (!this.$route.query.reportType) {
      this.$fullScreenLoading.show('请传参...')
      this.$message({
        message: '请传递有效参数！',
        type: 'warning'
      })
    } else {
      this.pageInfo = this.$route.query
      document.title = `学校报告 ${
        this.pageInfo.school
      }${new Date().toLocaleDateString()}`
      this.$fullScreenLoading.show('loading...')
      var that = this
      getChildrenTeamReportDetailData(that.queryParams)
        // request({
        //   url: "mirrorego/stuStatistic/detail",
        //   method: "POST",
        //   data: this.pageInfo,
        // })
        .then((res) => {
          this.baseData = res.data
          this.schoolType = res.data.schoolType
          this.SurveyPersonnelBodyList = [
            {
              totalTest: res.data.yinCeRenShu,
              ActualTest: res.data.shiCeRenShu,
              effectiveTest: res.data.youXiaoWenJuan,
              efficientTest: (res.data.youXiaoLu * 100).toFixed(2) + '%'
            }
          ]
          this.getData()
        })
    }
  },
  mounted() {},
  methods: {
    formatTableValueData(key) {
      var list = []
      this.data.gradeData.forEach((ele) => {
        list.push({
          value: ele.scaleItems[key],
          className: ele.className || ele.gradeName
        })
      })
      return list
    },
    getData() {
      var that = this
      getChildrenTeamReportItemdetail2Data(that.queryParams)
        // request({
        //   url: "mirrorego/stuStatistic/itemdetail2",
        //   method: "POST",
        //   data: this.pageInfo,
        // })
        .then((res) => {
          this.data = res.data
          if (res.data.gradeData !== undefined) {
            res.data.gradeData.forEach((gradeChartData) => {
              if (gradeChartData.classicsData !== undefined) {
                gradeChartData.classicsData.forEach((classF) => {
                  this.early1Data.className.push(
                    gradeChartData.gradeName + ' ' + classF.className
                  )
                  this.early2Data.className.push(
                    gradeChartData.gradeName + ' ' + classF.className
                  )
                  this.early3Data.className.push(
                    gradeChartData.gradeName + ' ' + classF.className
                  )
                  classF.alarmItems.forEach((alarm) => {
                    if (alarm.level === 1) {
                      this.early1Data.value.push(alarm.theNumberOfStudent)
                    } else if (alarm.level === 2) {
                      this.early2Data.value.push(alarm.theNumberOfStudent)
                    } else if (alarm.level === 3) {
                      this.early3Data.value.push(alarm.theNumberOfStudent)
                    }
                  })
                })
              }

              this.pieGradeChartData.name.push(gradeChartData.gradeName)
              this.earlyGrade.gradeName.push(gradeChartData.gradeName)
              this.pieGradeChartData.value.push({
                name: gradeChartData.gradeName,
                value: gradeChartData.summary.theNumberOfStudent
              })
              var grade = {
                name: [],
                remark: '',
                value: []
              }

              if (
                gradeChartData.classicChartData !== undefined &&
                gradeChartData.classicChartData !== null
              ) {
                grade.name = gradeChartData.classicChartData.category
                grade.gradeName = gradeChartData.gradeName
                grade.remark = gradeChartData.classicChartData.remark
                for (const key in gradeChartData.classicChartData.series) {
                  grade.value.push({
                    name: key,
                    data: gradeChartData.classicChartData.series[key],
                    type: 'bar'
                  })
                }
              }

              this.gradeAboutClassChartData.push(grade)
              var value = []
              gradeChartData.alarmItems.forEach((alarmItems) => {
                this.earlyGrade.name.push(alarmItems.levelName)
                value.push(alarmItems.theNumberOfStudent)
              })
              this.earlyGrade.value.push({
                label: {
                  // 图形上的文本标签
                  show: true,
                  position: ['78%', '-50'], // 相对位置
                  rotate: -90, // 旋转角度
                  color: '#D9D2E9',
                  fontSize: 20
                },
                itemStyle: {
                  // 图形的形状
                  barBorderRadius: 5
                },
                name: gradeChartData.gradeName,
                type: 'bar',
                data: value
              })
            })
          }

          res.data.totalScale.forEach((item) => {
            this.HealthSummaryPieChartData.push({
              name: item.conclusion,
              value: item.theNumberOfStudent
            })
            this.barGradeBaGChart.man.push(item.theNumberOfMan)
            this.barGradeBaGChart.male.push(item.theNumberOfFemale)
            this.barGradeBaGChart.name.push(item.conclusion)
          })
          res.data.alarmItems.forEach((alert) => {
            this.EarlyPieChartData.push({
              name: alert.levelName,
              value: alert.theNumberOfStudent
            })
          })
          this.gradeChartData.name = res.data.gradeChartData.category
          this.gradeChartData.remark = res.data.gradeChartData.remark
          for (const key in res.data.gradeChartData.series) {
            this.gradeChartData.value.push({
              name: key,
              data: res.data.gradeChartData.series[key],
              type: 'bar'
            })
          }
          this.barDimentionChartData.remark = res.data.yuJinItemChart.remark
          this.barDimentionChartData.className =
            res.data.yuJinItemChart.category
          for (const key in res.data.yuJinItemChart.series) {
            this.barDimentionChartData.dimentionName.push(key)
            this.barDimentionChartData.value.push({
              name: key,
              type: 'bar',
              data: res.data.yuJinItemChart.series[key]
            })
          }
          setTimeout(() => {
            // 男／女生参测人员分布情况 饼图
            this.getTotalPieChart()
            // 各班级参测人员分布情况 饼图
            this.getPieClassChart()
            // 各年级心理健康状态汇总 柱状图
            this.getBarGradeChart()
            // 各班级心理健康状态汇总 柱状图
            this.getEarlyPieChart()
            for (
              let index = 0;
              index < this.gradeAboutClassChartData.length;
              index++
            ) {
              this.getEachBarClassChart(
                this.gradeAboutClassChartData[index],
                index
              )
            }
            // 男/女心理健康
            this.getbarPercentageChart()
            // 学生心理健康状态汇总 饼图
            this.getHealthSummaryPieChart()
            // 各年级预警人数汇总 饼图
            this.getGradeBarEarlyChart()
            this.getlevel1EarlyClassBarChart()
            this.getlevel2EarlyClassBarChart()
            this.getlevel3EarlyClassBarChart()
            // this.getbarPercentageChart()
            // this.getBarClassEarlyChart()
            this.getbarDimentionChart()
            this.$fullScreenLoading.hide()
            if (this.isExport) {
              this.$notify({
                title: '成功',
                message: '下载PDF中，请稍等一会',
                duration: 2000,
                type: 'success'
              })
              setTimeout(() => {
                htmlToPdf.downloadPDF(
                  document.querySelector('#main'),
                  `学校报告 ${
                    this.$route.query.school
                  }${new Date().toLocaleDateString()}.pdf`
                )
              }, 1000)
              //   setTimeout(() => {
              //     getReportPdf("#main", `学校报告 ${this.$route.query.school}${new Date().toLocaleDateString()}.pdf`,0.8);
              //  }, 1000);
            }
          }, 1000)
        })
    },
    // 男／女生参测人员分布情况 饼图
    getTotalPieChart() {
      const { shiCeRenShuFemale, shiCeRenShuMan } = this.baseData
      var option = {
        tooltip: {
          trigger: 'item'
        },
        legend: {
          orient: 'horizontal',
          x: 'center',
          y: 'bottom',
          data: ['男', '女'],
          itemWidth: 30, // 设置图例图形的宽
          itemHeight: 14, // 设置图例图形的高
          itemGap: 30,
          textStyle: {
            fontSize: 20
          }
        },
        color: ['#FFCF58', '#409EFF'],
        series: [
          {
            name: '男／女生参测人员分布情况',
            type: 'pie',
            radius: '70%',
            data: [
              { value: shiCeRenShuFemale, name: '女' },
              { value: shiCeRenShuMan, name: '男' }
            ],
            emphasis: {
              itemStyle: {
                shadowBlur: 10,
                shadowOffsetX: 0,
                shadowColor: 'rgba(0, 0, 0, 0.5)'
              }
            },
            label: {
              normal: {
                fontSize: 28,
                position: 'inner', // 设置标签位置，默认在饼状图外 可选值：'outer' ¦ 'inner（饼状图上）'
                // formatter: '{a} {b} : {c}个 ({d}%)'   设置标签显示内容 ，默认显示{b}
                // {a}指series.name  {b}指series.data的name
                // {c}指series.data的value  {d}%指这一部分占总数的百分比
                formatter: '{d}%'
              }
            }
          }
        ]
      }
      var myCharts = this.$Echarts.init(
        document.getElementById('piePercentageChart')
      )
      myCharts.setOption(option)
    },
    // 各班级参测人员分布情况 饼图
    getPieClassChart() {
      var option = {
        tooltip: {
          trigger: 'item'
        },
        legend: {
          orient: 'horizontal',
          x: 'center',
          y: 'bottom',
          data: this.pieGradeChartData.name,
          itemWidth: 30, // 设置图例图形的宽
          itemHeight: 14, // 设置图例图形的高
          itemGap: 30,
          textStyle: {
            fontSize: 20
          }
        },
        series: [
          {
            name: '各年级参测人员分布情况',
            type: 'pie',
            radius: '70%',
            data: this.pieGradeChartData.value,
            emphasis: {
              itemStyle: {
                shadowBlur: 10,
                shadowOffsetX: 0,
                shadowColor: 'rgba(0, 0, 0, 0.5)'
              }
            },
            label: {
              normal: {
                fontSize: 28,
                position: 'inner', // 设置标签位置，默认在饼状图外 可选值：'outer' ¦ 'inner（饼状图上）'
                // formatter: '{a} {b} : {c}个 ({d}%)'   设置标签显示内容 ，默认显示{b}
                // {a}指series.name  {b}指series.data的name
                // {c}指series.data的value  {d}%指这一部分占总数的百分比
                formatter: '{d}%'
              }
            }
          }
        ]
      }
      var myCharts = this.$Echarts.init(
        document.getElementById('pieClassChart')
      )
      myCharts.setOption(option)
    },
    // 各年级心理健康状态汇总 柱状图
    getBarGradeChart() {
      var option = {
        tooltip: {
          trigger: 'axis',
          axisPointer: {
            type: 'shadow'
          }
        },
        legend: {
          data: [
            '高健康状态',
            '较好健康状态',
            '一般健康状态',
            '亚健康状态',
            '预警状态'
          ]
        },
        color: ['#ff4d4c', '#FFCF58', '#92E35C', '#0BCC53', '#FD8E44'],
        grid: {
          left: '3%',
          right: '4%',
          bottom: '3%',
          containLabel: true
        },
        xAxis: {
          type: 'category',
          data: this.gradeChartData.name
        },
        yAxis: {
          type: 'value',
          boundaryGap: [0, 0.01]
        },
        series: this.gradeChartData.value
      }
      var myCharts = this.$Echarts.init(
        document.getElementById('barClassChart')
      )
      myCharts.setOption(option)
    },
    // 各班级心理健康状态汇总 柱状图 需遍历
    getEachBarClassChart(item, index) {
      var option = {
        title: {
          text: item.gradeName
        },
        tooltip: {
          trigger: 'axis',
          axisPointer: {
            type: 'shadow'
          }
        },
        color: ['#ff4d4c', '#FFCF58', '#92E35C', '#0BCC53', '#FD8E44'],
        legend: {
          data: [
            '高健康状态',
            '较好健康状态',
            '一般健康状态',
            '亚健康状态',
            '预警状态'
          ]
        },
        grid: {
          left: '3%',
          right: '4%',
          bottom: '3%',
          containLabel: true
        },
        xAxis: {
          type: 'value',
          boundaryGap: [0, 0.01]
        },
        yAxis: {
          type: 'category',
          data: item.name
        },
        series: item.value
      }
      var myCharts = this.$Echarts.init(
        document.getElementById('barEachClassChart' + index)
      )
      myCharts.setOption(option)
    },
    // 学生心理健康状态汇总 饼图
    getHealthSummaryPieChart() {
      var option = {
        tooltip: {
          trigger: 'item'
        },
        legend: {
          orient: 'vertical',
          x: 'left',
          y: 'center',
          itemWidth: 20, // 设置图例图形的宽
          itemHeight: 20, // 设置图例图形的高
          itemGap: 38,
          textStyle: {
            fontSize: 20
          }
        },
        color: ['#ff4d4c', '#FD8E44', '#FFCF58', '#92E35C', '#0BCC53'],
        series: [
          {
            name: '学生心理健康状态汇总',
            type: 'pie',
            radius: '70%',
            data: this.HealthSummaryPieChartData,
            selectedMode: 'single',
            selectedOffset: 30,
            clockwise: true,
            label: {
              normal: {
                fontSize: 24, // 设置标签位置，默认在饼状图外 可选值：'outer' ¦ 'inner（饼状图上）'
                // formatter: '{a} {b} : {c}个 ({d}%)'   设置标签显示内容 ，默认显示{b}
                // {a}指series.name  {b}指series.data的name
                // {c}指series.data的value  {d}%指这一部分占总数的百分比
                formatter: '{b}{d}%'
              }
            },
            emphasis: {
              itemStyle: {
                shadowBlur: 10,
                shadowOffsetX: 0,
                shadowColor: 'rgba(0, 0, 0, 0.5)'
              }
            }
          }
        ]
      }
      var myCharts = this.$Echarts.init(
        document.getElementById('healthSummaryChart')
      )
      myCharts.setOption(option)
    },
    // 男／女生心理健康状态汇总 柱状图
    getBarGradeBaGChart() {
      const { man, male, name } = this.barGradeBaGChart
      var option = {
        tooltip: {
          trigger: 'axis',
          axisPointer: {
            type: 'shadow'
          }
        },
        legend: {
          data: ['男', '女']
        },
        grid: {
          left: '3%',
          right: '4%',
          bottom: '3%',
          containLabel: true
        },
        xAxis: {
          type: 'category',
          data: name
        },
        yAxis: {
          type: 'value',
          boundaryGap: [0, 0.01]
        },
        series: [
          {
            name: '男',
            type: 'bar',
            data: man
          },
          {
            name: '女',
            type: 'bar',
            data: male
          }
        ]
      }
      var myCharts = this.$Echarts.init(
        document.getElementById('barGradeBaGChart')
      )
      myCharts.setOption(option)
    },
    getbarPercentageChart() {
      const { man, male, name } = this.barGradeBaGChart
      var option = {
        tooltip: {
          trigger: 'axis',
          axisPointer: {
            type: 'shadow'
          }
        },
        legend: {
          data: ['男生', '女生'],
          itemWidth: 30, // 设置图例图形的宽
          itemHeight: 14, // 设置图例图形的高
          itemGap: 41,
          textStyle: {
            fontSize: 20
          }
        },
        xAxis: {
          nameTextStyle: {
            // 坐标轴名称样式
            color: '#A8A8AC',
            fontSize: 20
          },
          axisLine: {
            // 网格区域
            show: false // 是否显示，默认为false
          },
          axisTick: { show: false },
          type: 'category',
          data: name
        },
        yAxis: {
          nameTextStyle: {
            // 坐标轴名称样式
            color: '#A8A8A8',
            fontSize: 20
          },
          splitLine: { show: false },
          type: 'value'
        },
        series: [
          {
            label: {
              // 图形上的文本标签
              show: true,
              position: ['78%', '-50'], // 相对位置
              rotate: -90, // 旋转角度
              color: '#D9D2E9',
              fontSize: 20
            },
            itemStyle: {
              // 图形的形状
              color: '#409EFF',
              barBorderRadius: 5
            },
            name: '男生',
            type: 'bar',
            data: man
          },
          {
            itemStyle: {
              // 图形的形状
              color: '#FFCF58',
              barBorderRadius: 5
            },
            label: {
              // 图形上的文本标签
              show: true,
              position: ['78%', '-50'], // 相对位置
              rotate: -90, // 旋转角度
              color: '#D9D2E9',
              fontSize: 20
            },
            name: '女生',
            type: 'bar',
            data: male
          }
        ]
      }
      var myChart = this.$Echarts.init(
        document.getElementById('barGradeBaGChart')
      )
      myChart.setOption(option)
    },
    getEarlyPieChart() {
      var option = {
        tooltip: {
          trigger: 'item'
        },
        color: ['#92E35C', '#f20c00', '#f35336', 'yellow'],
        legend: {
          orient: 'vertical',
          x: 'left',
          y: 'center',
          itemWidth: 20, // 设置图例图形的宽
          itemHeight: 20, // 设置图例图形的高
          itemGap: 38,
          textStyle: {
            fontSize: 20
          }
        },
        series: [
          {
            name: '学生心理健康状态汇总',
            type: 'pie',
            radius: '70%',
            data: this.EarlyPieChartData,
            selectedMode: 'single',
            selectedOffset: 30,
            clockwise: true,
            label: {
              normal: {
                fontSize: 24, // 设置标签位置，默认在饼状图外 可选值：'outer' ¦ 'inner（饼状图上）'
                // formatter: '{a} {b} : {c}个 ({d}%)'   设置标签显示内容 ，默认显示{b}
                // {a}指series.name  {b}指series.data的name
                // {c}指series.data的value  {d}%指这一部分占总数的百分比
                formatter: '{b}{d}%'
              }
            },
            emphasis: {
              itemStyle: {
                shadowBlur: 10,
                shadowOffsetX: 0,
                shadowColor: 'rgba(0, 0, 0, 0.5)'
              }
            }
          }
        ]
      }
      var myCharts = this.$Echarts.init(
        document.getElementById('EarlyPieChart')
      )
      myCharts.setOption(option)
    },
    getBarClassEarlyChart() {
      var option = {
        tooltip: {
          trigger: 'axis',
          axisPointer: {
            type: 'shadow'
          }
        },
        legend: {
          data: [
            '高健康状态',
            '较好健康状态',
            '一般健康状态',
            '亚健康状态',
            '预警状态'
          ]
        },
        color: ['#ff4d4c', '#FFCF58', '#92E35C', '#0BCC53', '#FD8E44'],
        grid: {
          left: '3%',
          right: '4%',
          bottom: '3%',
          containLabel: true
        },
        xAxis: {
          type: 'category',
          data: [
            '一年级（1班）',
            '一年级（2班）',
            '一年级（3班）',
            '一年级（4班）',
            '一年级（5班）',
            '一年级（6班）'
          ]
        },
        yAxis: {
          type: 'value',
          boundaryGap: [0, 0.01]
        },
        series: [
          {
            name: '高健康状态',
            type: 'bar',
            data: [18203, 23489, 29034, 104970, 131744, 630230]
          },
          {
            name: '较好健康状态',
            type: 'bar',
            data: [19325, 23438, 31000, 121594, 134141, 681807]
          },
          {
            name: '一般健康状态',
            type: 'bar',
            data: [19325, 23438, 31000, 121594, 134141, 681807]
          },
          {
            name: '亚健康状态',
            type: 'bar',
            data: [19325, 23438, 31000, 121594, 134141, 681807]
          },
          {
            name: '预警状态',
            type: 'bar',
            data: [19325, 23438, 31000, 121594, 134141, 681807]
          }
        ]
      }
      var myCharts = this.$Echarts.init(
        document.getElementById('barDimentionChart')
      )
      myCharts.setOption(option)
    },
    getGradeBarEarlyChart() {
      var option = {
        tooltip: {
          trigger: 'axis',
          axisPointer: {
            type: 'shadow'
          }
        },
        legend: {
          data: Array.from(new Set(this.earlyGrade.name)),
          itemWidth: 30, // 设置图例图形的宽
          itemHeight: 14, // 设置图例图形的高
          itemGap: 41,
          textStyle: {
            fontSize: 20
          }
        },
        xAxis: {
          nameTextStyle: {
            // 坐标轴名称样式
            color: '#A8A8AC',
            fontSize: 20
          },
          axisLine: {
            // 网格区域
            show: false // 是否显示，默认为false
          },
          axisTick: { show: false },
          type: 'category',
          data: ['非预警', '第一类预警', '第二类预警', '第三类预警']
        },
        yAxis: {
          nameTextStyle: {
            // 坐标轴名称样式
            color: '#A8A8A8',
            fontSize: 20
          },
          splitLine: { show: false },
          type: 'value'
        },
        series: this.earlyGrade.value
      }
      var myChart = this.$Echarts.init(
        document.getElementById('gradeBarChart')
      )
      myChart.setOption(option)
    },
    getbarDimentionChart() {
      var option = {
        tooltip: {
          trigger: 'axis',
          axisPointer: {
            type: 'shadow'
          }
        },
        legend: {
          data: this.barDimentionChartData.dimentionName
        },
        grid: {
          left: '3%',
          right: '4%',
          bottom: '3%',
          containLabel: true
        },
        xAxis: {
          type: 'category',
          data: this.barDimentionChartData.className
        },
        yAxis: {
          type: 'value',
          boundaryGap: [0, 0.01]
        },
        series: this.barDimentionChartData.value
      }
      var myCharts = this.$Echarts.init(
        document.getElementById('barDimentionChart')
      )
      myCharts.setOption(option)
    },
    getlevel1EarlyClassBarChart() {
      var option = {
        title: {
          text: '第一类预警人数对比'
        },
        tooltip: {
          trigger: 'axis',
          axisPointer: {
            type: 'shadow'
          }
        },
        color: '#FFCF58',
        grid: {
          left: '3%',
          right: '4%',
          bottom: '3%',
          containLabel: true
        },
        xAxis: {
          type: 'value',
          axisLine: {
            // 网格区域
            show: false // 是否显示，默认为false
          },

          splitLine: { show: false },
          axisTick: { show: false },
          boundaryGap: [0, 0.01]
        },
        yAxis: {
          axisLine: {
            // 网格区域
            show: false // 是否显示，默认为false
          },
          axisTick: { show: false },
          splitLine: { show: false },
          type: 'category',
          data: this.early1Data.className
        },
        series: [
          {
            name: '第一类预警人数',
            type: 'bar',
            data: this.early1Data.value
          }
        ]
      }
      var myCharts = this.$Echarts.init(
        document.getElementById('level1EarlyBarChart')
      )
      myCharts.setOption(option)
    },
    getlevel2EarlyClassBarChart() {
      var option = {
        title: {
          text: '第二类预警人数对比'
        },
        tooltip: {
          trigger: 'axis',
          axisPointer: {
            type: 'shadow'
          }
        },
        color: '#FFCF58',
        grid: {
          left: '3%',
          right: '4%',
          bottom: '3%',
          containLabel: true
        },
        xAxis: {
          type: 'value',
          axisLine: {
            // 网格区域
            show: false // 是否显示，默认为false
          },

          splitLine: { show: false },
          axisTick: { show: false },
          boundaryGap: [0, 0.01]
        },
        yAxis: {
          axisLine: {
            // 网格区域
            show: false // 是否显示，默认为false
          },
          axisTick: { show: false },
          splitLine: { show: false },
          type: 'category',
          data: this.early2Data.className
        },
        series: [
          {
            name: '第二类预警人数',
            type: 'bar',
            data: this.early2Data.value
          }
        ]
      }
      var myCharts = this.$Echarts.init(
        document.getElementById('level2EarlyBarChart')
      )
      myCharts.setOption(option)
    },
    getlevel3EarlyClassBarChart() {
      var option = {
        title: {
          text: '第三类预警人数对比'
        },
        tooltip: {
          trigger: 'axis',
          axisPointer: {
            type: 'shadow'
          }
        },
        color: '#FFCF58',
        grid: {
          left: '3%',
          right: '4%',
          bottom: '3%',
          containLabel: true
        },
        xAxis: {
          type: 'value',
          axisLine: {
            // 网格区域
            show: false // 是否显示，默认为false
          },

          splitLine: { show: false },
          axisTick: { show: false },
          boundaryGap: [0, 0.01]
        },
        yAxis: {
          axisLine: {
            // 网格区域
            show: false // 是否显示，默认为false
          },
          axisTick: { show: false },
          splitLine: { show: false },
          type: 'category',
          data: this.early3Data.className
        },
        series: [
          {
            name: '第三类预警人数',
            type: 'bar',
            data: this.early3Data.value
          }
        ]
      }
      var myCharts = this.$Echarts.init(
        document.getElementById('level3EarlyBarChart')
      )
      myCharts.setOption(option)
    }
  }
}

// setTimeout(() => {
//               try {
//                 var html = document.querySelector("#main");
//                 let contentWidth = html.clientWidth; // 获得该容器的宽
//                 let contentHeight = html.clientHeight; // 获得该容器的高
//                 let canvas = document.createElement("canvas");
//                 let scale = 1; // 解决清晰度问题，先放大 2倍

//                 canvas.width = contentWidth * scale; // 将画布宽&&高放大两倍
//                 canvas.height = contentHeight * scale;
//                 canvas.getContext("2d").scale(scale, scale);

//                 let opts = {
//                   scale: scale,
//                   canvas: canvas,
//                   // width: contentWidth,
//                   // height: contentHeight,
//                   useCORS: true,
//                 };
//                 window.Html2canvas ||
//                   Html2Canvas(html, opts)
//                     .then((canvas) => {
//                       var contentWidth = canvas.width;
//                       var contentHeight = canvas.height;

//                       //一页pdf显示html页面生成的canvas高度;
//                       var pageHeight = (contentWidth / 592.28) * 841.89;
//                       //未生成pdf的html页面高度
//                       var leftHeight = contentHeight;
//                       //页面偏移
//                       var position = 0;
//                       //a4纸的尺寸[595.28,841.89]，html页面生成的canvas在pdf中图片的宽高
//                       var imgWidth = 595.28;
//                       var imgHeight = (592.28 / contentWidth) * contentHeight;

//                       var pageData = canvas.toDataURL("image/jpeg", 1.0);

//                       var pdf = new jsPDF("", "pt", "a4");

//                       //有两个高度需要区分，一个是html页面的实际高度，和生成pdf的页面高度(841.89)
//                       //当内容未超过pdf一页显示的范围，无需分页
//                       if (leftHeight < pageHeight) {
//                         pdf.addImage(
//                           pageData,
//                           "JPEG",
//                           0,
//                           0,
//                           imgWidth,
//                           imgHeight
//                         );
//                       } else {
//                         while (leftHeight > 0) {
//                           pdf.addImage(
//                             pageData,
//                             "JPEG",
//                             0,
//                             position,
//                             imgWidth,
//                             imgHeight
//                           );
//                           leftHeight -= pageHeight;
//                           position -= 841.89;
//                           //避免添加空白页
//                           if (leftHeight > 0) {
//                             pdf.addPage();
//                           }
//                         }
//                       }
//                       pdf.save(
//                         `学校报告 ${
//                           this.pageInfo.school
//                         }${new Date().toLocaleDateString()}.pdf`
//                       );
//                       //
//                     })
//                     .catch((err) => {
//                     });
//               } catch (err) {
//               }
//             }, 1000);
</script>
<style lang="scss">
.reportContainer {
  width: 100%;
  overflow: hidden;
  padding-bottom: 304px;
  .wsTableList {
    max-width: 80% !important;
  }
  .pieChart {
    width: 100%;
    margin: 0 auto;
    display: flex;
    align-items: center;
    justify-content: center;
    .pie {
      width: 100%;
      height: 550px;
    }
    #barPercentageChart,
    #EarlyBarChart,
    #barDimentionChart,
    #level1EarlyBarChart,
    #level2EarlyBarChart,
    #level3EarlyBarChart {
      margin-top: 52px;
      padding: 0 262px;
    }
    #barClassChart {
      //   width: 600px;
      height: 1100px;
    }
  }
  .coverContainer {
    img {
      width: 100%;
      height: auto;
    }
    margin: 0 auto;
    position: relative;
    .coverInfo {
      position: absolute;
      z-index: 1;
      top: 38%;
      left: 50%;
      font-size: 42px;
      color: #fff;
      font-weight: 700;
    }
  }
  .bigTitle {
    width: 620px;
    height: 56px;
    margin: 64px auto 101px;
  }
  .scienceT {
    background: url("../../assets/images/classReport/scienceT.png") no-repeat
      center;
    background-size: 100% 100%;
  }
  .noticeT {
    background: url("../../assets/images/classReport/noticeT.png") no-repeat
      center;
    background-size: 100% 100%;
  }
  .introT {
    background: url("../../assets/images/caseReport/intro_bigTitle.png")
      no-repeat center;
    background-size: 100% 100%;
  }
  .summaryT {
    background: url("../../assets/images/classReport/summaryT.png") no-repeat
      center;
    background-size: 100% 100%;
  }
  .partTest {
    background: url("../../assets/images/classReport/partTest.png") no-repeat
      center;
    background-size: 100% 100%;
    margin-top: 88px;
  }
  .resultT {
    background: url("../../assets/images/classReport/resultT.png") no-repeat
      center;
    background-size: 100% 100%;
    margin-top: 125px;
  }
  .intro {
    width: 100%;
    padding: 0 143px;
    font-size: 28px;
    font-weight: 400;
    color: #333333;
    line-height: 56px;
    .introItem {
      margin-bottom: 58px;
    }
  }
  .formatIntro {
    width: 100%;
    padding: 0 143px;
    font-size: 28px;
    font-weight: 400;
    color: #333333;
    margin: 47px 0 23px 0;
    line-height: 56px;
    span {
      font-size: 32px;
      font-weight: bold;
      color: #fab839;
      margin: 0 10px;
    }
  }
  .SurveyingContainner {
    background: none !important;
    margin-top: 68px;
  }
  .detailContainner {
    width: 100%;
    padding: 0 143px;
    background: url("../../assets/images/classReport/referenceBg.png") no-repeat
      right;
    background-size: 500px 580px;
    .detailItem {
      .itemTitle {
        width: 310px;
        height: 50px;
        img {
          width: 100%;
          height: 100%;
        }
      }
      .itemValue {
        font-size: 28px;
        font-weight: 400;
        color: #333333;
        line-height: 56px;
        margin-bottom: 47px;
      }
    }
  }
  .listContainer {
    width: 100%;
    padding: 0 143px;
    margin-top: 60px;
    .listItem {
      display: flex;
      flex-direction: column;
      margin-bottom: 37px;
      .listTitle {
        display: flex;
        align-items: center;
        .icon {
          width: 34px;
          height: 34px;
          background: url("../../assets/images/caseReport/list_left.png")
            no-repeat center;
          background-size: 100% 100%;

          margin-right: 26px;
        }
        .title {
          font-size: 28px;
          font-weight: 400;
          color: #333333;
        }
      }
      .listValue {
        padding-top: 45px;
        font-size: 28px;
        font-weight: 300;
        color: #333333;
        line-height: 56px;
      }
    }
  }
  .literatureContainer {
    width: 100%;
    min-height: 900px;
    padding: 0 143px;

    margin-top: 60px;
    .literatureItem {
      display: flex;
      margin-bottom: 37px;
      .literatureTitle {
        width: 34px;
        padding-top: 10px;
        margin-right: 26px;
        .icon {
          width: 34px;
          height: 34px;
          background: url("../../assets/images/caseReport/list_left.png")
            no-repeat center;
          background-size: 100% 100%;
        }
      }
      .literatureValue {
        width: 819px;
        font-size: 28px;
        font-weight: 400;
        color: #333333;
        line-height: 56px;
      }
    }
  }
  .resultChart {
    width: 100%;
    height: 450px;
    margin: 0 auto;
    display: flex;
    align-items: center;
    justify-content: center;
    #myCharts {
      width: 100%;
      height: 100%;
    }
  }

  @media screen and (min-width: 300px) and (max-width: 800px) {
    .intro {
      line-height: 100px;
    }
  }
}
</style>
